
import { StripeProvider, Elements, injectStripe } from 'react-stripe-elements'
import { connect, useDispatch } from 'react-redux'
import React, { useState } from 'react'

import SubscribeScanForm from '@components/SubscribeScanForm/SubscribeScanForm'
import axiosClient from '../../../api/axios-client'
import { notify } from 'Actions/notifications'
import { openModal } from 'Actions/ui'
import { setCurrentUser } from 'Actions/user'
import { getUser } from '../../../api/user'
import { STRIPE_PUBLIC_KEY } from 'Config/constants'
import { get } from 'lodash'

const LetterBoxChangeExpedition = ({ currentUser, afterValidate }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [isOpen, setOpen] = useState(true)
  const dispatch = useDispatch()

  if (!isOpen) return null
  if (!currentUser.company) return null

  const contract = get(currentUser, 'contracts.0', {})
  const { offer_version } = contract
  if (contract.expedition_frequency === 'scan') return null
  if (contract.expedition_frequency === 'scan_recyclage' && offer_version === 'v1') return null

  const stripeAccount = get(currentUser, 'company.idStripeAccount') || undefined

  const refreshUser = async () => {
    getUser(res => {
      dispatch(setCurrentUser(res))
    })
  }

  const handleChangeOffer = async (stripe) => {
    setIsLoading(true)

    try {
      const res = await axiosClient.post('/api/user/subscribe-to-expedition-or-scan')

      console.log('res change offer ------------------------------------------>')
      console.log(res)
      const { validated, client_secret } = res.data

      if (!validated) {
        const res = await stripe.handleCardPayment(client_secret, {})
        console.log('res handleCardPayment ------------------------------------------>')
        console.log(res)

        setIsLoading(false)

        if (res.error) {
          dispatch(
            openModal('notification', {
              message: 'Changement d’offre validé, mais le paiement a été refusé, veuillez vérifier l’approvisionnement de votre carte et renseigner à nouveau un moyen de paiement dans l’onglet "Moyen de paiement".',
              buttonText: 'Ok',
            }),
          )

          return
        }
      }

      setIsLoading(false)
      dispatch(notify('success', 'Changement validé.'))
      refreshUser()
      afterValidate && afterValidate()
    } catch (e) {
      console.log('e ------------------------------------------>')
      console.log(e)
      setIsLoading(false)
      dispatch(
        notify('error', 'Une erreur est survenue lors de la modification de votre abonnement.'),
      )
    }
  }

  const text = offer_version === 'v1'
    ? `Si vous souhaitez pouvoir consulter ici votre courrier scanné dès le lendemain de sa réception, vous pouvez activer l'option "Scan", sans engagement, au tarif de 10 € HT/mois.`
    : <span>Tous vos courriers sont numérisés, conservés pendant une durée de 3 mois, puis recyclés.<br />Si vous souhaitez recevoir les originaux en fin de mois, vous pouvez activer l’option de réexpédition mensuelle, sans engagement, au tarif de 10 € HT/mois.</span>

  return (
    <StripeProvider apiKey={STRIPE_PUBLIC_KEY} stripeAccount={stripeAccount}>
      <Elements locale="fr">
        <div className="bg-new-verylight-gray border-verylight-gray border-1 px-5 py-5 rounded relative mb-8 md:mb-12">
          <img onClick={() => setOpen(false)} src="/assets/icons/icon-cross.svg" className="cursor-pointer absolute top-1 right-1" alt="fermer" />
          <div className="text-justify mb-3">{text}</div>
          <div className="text-center">
            <SubscribeScanForm
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              interval={currentUser.payment_interval === 'mensuel' ? 'month' : 'year'}
              offerVersion={offer_version}
              handleChangeOffer={handleChangeOffer}
            />
          </div>
        </div>
      </Elements>
    </StripeProvider>
  )
}

const MapStateToProps = state => ({
  currentUser: state.user.currentUser,
})

export default connect(MapStateToProps)(LetterBoxChangeExpedition)